module.exports = __webpack_public_path__ + "static/media/almaDeRoble.dce9af2d.png";